import { writable } from '../../_snowpack/pkg/svelte/store.js';

export const searchResult = writable();

export const isLoading = writable();

export const sitePrefix = writable('');